import { render, staticRenderFns } from "./materialWorkorder.vue?vue&type=template&id=6db05cfd&scoped=true"
import script from "./materialWorkorder.vue?vue&type=script&lang=js"
export * from "./materialWorkorder.vue?vue&type=script&lang=js"
import style0 from "./materialWorkorder.vue?vue&type=style&index=0&id=6db05cfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db05cfd",
  null
  
)

export default component.exports